import type { CoverLetterData } from "./index";

export const sampleCoverLetter: CoverLetterData = {
  sender: {
    name: "John Doe",
    email: "john.doe@gmail.com",
    phone: "(555) 123-4567",
    location: "San Francisco, CA 94105",
    url: {
      label: "Portfolio",
      href: "https://johndoe.me/",
    },
    linkedinUrl: {
      label: "LinkedIn",
      href: "https://linkedin.com/in/johndoe",
    },
    picture: {
      url: "https://i.imgur.com/HgwyOuJ.jpg",
      size: 64,
      aspectRatio: 1,
      borderRadius: 0,
      effects: { hidden: false, border: false, grayscale: false },
    },
    customFields: [],
  },
  recipient: {
    name: "Sarah Johnson",
    title: "Engineering Manager",
    company: "TechCorp Inc.",
    department: "Software Engineering",
    address: "100 Market Street, San Francisco, CA 94105",
  },
  letter: {
    date: "March 31, 2026",
    subject: "",
    greeting: "Dear Ms. Johnson,",
    opening:
      "<p>I am writing to express my strong interest in the Senior Software Engineer position at TechCorp Inc., as advertised on your careers page. With over 7 years of experience building scalable web applications and leading cross-functional teams, I am confident that my technical expertise and passion for innovative solutions make me an excellent fit for this role.</p>",
    body: "<p>In my current role at WebDev Solutions, I led the development of a microservices architecture that reduced API response times by 40% and improved system reliability to 99.9% uptime. I also spearheaded the adoption of TypeScript across our frontend codebase, resulting in a 60% reduction in production bugs. My experience with React, Node.js, and cloud infrastructure on AWS aligns directly with the requirements outlined in your job description.</p><p>Beyond technical skills, I am passionate about mentoring junior developers and fostering a collaborative team culture. I initiated a weekly knowledge-sharing session that improved onboarding time for new team members by 30%.</p>",
    closing:
      "<p>I am excited about the opportunity to contribute to TechCorp's mission of building next-generation developer tools. I would welcome the chance to discuss how my experience and skills can help drive your team's success. Thank you for considering my application — I look forward to hearing from you.</p>",
    signOff: "Sincerely,",
    enclosures: "Encl: Resume",
  },
  reference: {
    jobTitle: "",
    referenceNumber: "",
    source: "",
  },
  custom: {},
  metadata: {
    template: "professional",
    layout: [
      [
        ["date", "recipient", "reference", "letter", "signoff", "enclosures"],
        [],
      ],
    ],
    css: { value: "", visible: false },
    page: {
      margin: 18,
      format: "a4",
      options: { breakLine: false, pageNumbers: false },
    },
    theme: {
      background: "#ffffff",
      text: "#000000",
      primary: "#1e40af",
    },
    typography: {
      font: {
        family: "IBM Plex Serif",
        subset: "latin",
        variants: ["regular", "italic", "600"],
        size: 14,
      },
      lineHeight: 1.6,
      hideIcons: false,
      underlineLinks: true,
    },
    notes: "",
  },
};
